// extracted by mini-css-extract-plugin
module.exports = {"plans":"PlanList_plans__TSe1w","plans__item":"PlanList_plans__item__c3P0k","plans__input":"PlanList_plans__input___zkA9","plans__plan":"PlanList_plans__plan__PiIRn"};